import * as React from 'react';

function SvgSpringMinus10(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.467 24.486v7.273l-10.052 6.828L33.52 52.243 13.415 65.9 33.52 79.556 13.415 93.212 33.52 106.87l-20.104 13.656 20.104 13.656-20.104 13.656 20.104 13.657-20.104 13.656 20.104 13.656-10.052 6.828v7.274"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M20.968 249.529v1.956l-17.04 2.59 20.104 3.056-20.103 3.056 20.103 3.056-20.103 3.056 20.103 3.056-20.103 3.056 20.103 3.055-20.103 3.056 20.103 3.056-20.103 3.056 20.103 3.055-3.064.466V292.236h5v-1.956l17.039-2.591-20.104-3.055 20.104-3.056-20.104-3.056 20.104-3.056-20.102-3.055 20.102-3.056-20.104-3.055 20.104-3.057-20.104-3.056 20.104-3.056-20.104-3.055 3.065-.466V249.529h-5z"
        fill={props.springcolor}
      />
      <path d="M35 0H12v23h23V0zM35 292H12v23h23v-23z" fill="#5BAD92" />
    </svg>
  );
}

export default SvgSpringMinus10;
